import React, { useEffect, useState } from 'react'
import ModalContainer from '../ModalContainer'
import "./reportModal.scss"
import moment from 'moment'
import { SocketState } from '../../../context/SocketProvider'
import { useDispatch, useSelector } from 'react-redux'
import { SET_MAIN_LOADER } from '../../../redux/loaderSlice'
import { SelectLotteryReport } from '../../../redux/2d-slice/gameInfo2dSlice'
import { reprortDataPrint } from '../../../comonComponent/print-2d/reportPrint'
import { AuthState } from '../../../context/AuthProvider'

function ReportModal2d() {
  const dispatch = useDispatch()
  const { socket } = SocketState()
  const lotteryReport = useSelector(SelectLotteryReport)
  let { userDetail } = AuthState()

  const [fromDate, setfromDate] = useState(moment().subtract(1, 'day').format('yyyy-MM-DD'))
  const [toDate, setToDate] = useState(moment().format('yyyy-MM-DD'))
  const [totalAmount, setTotalAmount] = useState([])

  useEffect(() => {
    submit()
  }, [])

  useEffect(() => {
    let finalData = { play_amount: 0, win_amount: 0, end_amount: 0, commission_amount: 0, final_amount: 0 }
    lotteryReport.forEach(element => {
      finalData.play_amount += element.play_amount
      finalData.win_amount += element.win_amount
      finalData.end_amount += element.end_amount
      finalData.commission_amount += element.commission_amount
      finalData.final_amount += (element.play_amount - element.win_amount) - element.commission_amount
    });
    setTotalAmount([...[finalData]])
  }, [lotteryReport])

  let submit = () => {
    dispatch(SET_MAIN_LOADER(true))
    let data = {
      "en": "MINI_LOTTERY_REPORT",
      "data": {
        "start_date": moment(fromDate, 'yyyy-MM-DD').format('DD-MM-yyyy'),
        "end_date": moment(toDate, 'yyyy-MM-DD').format('DD-MM-yyyy')
      }
    }
    socket.emit('req', data)
  }

  return (
    <ModalContainer title={'Reported'} navigation={'/2d'}>
      <div className="report_content">
        <div className="date_search_section flex items-center">
          <div className='w-full flex'>
            {/* 1 */}
            <div className='w-1/4 px-4'>
              <div className="mb-4">
                <label
                  className="block text-gray-700 text-sm font-bold mb-2" htmlFor="from">From</label>
                <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="from"
                  type="date"
                  placeholder="from"
                  value={fromDate}
                  onChange={(e) => {
                    // console.log("date", e.target.value)
                    setfromDate(e.target.value)
                  }}
                  max={moment().format('yyyy-MM-DD')}
                  min={'2023-04-1'}

                />
              </div>
            </div>

            {/* 2 */}
            <div className='w-1/4 px-4'>
              <div className="mb-4">
                <label
                  className="block text-gray-700 text-sm font-bold mb-2" htmlFor="to">To</label>
                <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="to"
                  type="date"
                  placeholder="to"
                  value={toDate}
                  onChange={(e) => {
                    // console.log("date", e.target.value)
                    setToDate(e.target.value)
                  }}
                  max={moment().format('yyyy-MM-DD')}
                // min={fromDate}
                />
              </div>
            </div>
            {/* 3 */}

            <div className='w-1/4 px-4 self-center'>
              <button
                className="bg-[#e54859] hover:bg-[#f03548] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full"
                type="button"
                onClick={submit}

              >
                Search
              </button>
            </div>
          </div>
        </div>

        <div className="report_table_div">
          <table className="table table-borderless report_table">
            <thead>
              <tr>
                <th>
                  <div></div>
                  Date
                </th>

                <th className="game_result_his2">
                  <div className="res_th_head1">Play  Points</div>
                </th>
                <th className="game_result_his3">
                  <div className="res_th_head1">Win Points</div>
                </th>
                <th className="game_result_his4">
                  <div className="res_th_head1">End  Points</div>
                </th>
                <th className="game_result_his5">
                  <div className="res_th_head1">Commision</div>
                </th>
                <th className="game_result_his6">
                  <div className="res_th_head1">Final Amount</div>
                </th>

              </tr>
            </thead>
            <tbody id="result_body">
              {totalAmount.length ? totalAmount.map((amount, index) => {
                return (
                  <tr key={index}>
                    <td>TOTAL VALUE</td>
                    <td>{Math.floor(amount.play_amount)}</td>
                    <td>{Math.floor(amount.win_amount)}</td>
                    <td>{Math.floor(amount.end_amount)}</td>
                    <td>{parseFloat(amount.commission_amount).toFixed(2)}</td>
                    <td>{Math.floor(amount.final_amount)}</td>
                  </tr>
                )
              }) : null}

              {lotteryReport.length ? lotteryReport.map((amount, index) => {
                return <tr key={index}>
                  <td>{moment(amount.date, 'DD:MM:YYYY').format('DD/MM/YYYY')}</td>
                  <td>{Math.floor(amount.play_amount)}</td>
                  <td>{Math.floor(amount.win_amount)}</td>
                  <td>{Math.floor(amount.end_amount)}</td>
                  <td>{parseFloat(amount.commission_amount).toFixed(2)}</td>
                  <td>{Math.floor((amount.play_amount - amount.win_amount) - amount.commission_amount)}</td>
                </tr>
              }) :
                <tr>
                  <td colSpan={6}> No Data Found </td>
                </tr>
              }

            </tbody>
          </table>
        </div>
        <div className='absolute bottom-0 left-0 w-full pb-4'>
          <div className='flex justify-end items-center mb-4 mr-4'>
            <button className='text-center w-1/6 rounded-lg py-3 bg-[#e54859] text-[white] font-semibold'
              // onClick={onSubmit}
              onClick={() => {
                dispatch(SET_MAIN_LOADER(true))
                reprortDataPrint(lotteryReport, dispatch, userDetail)
              }}
            >Print</button>


          </div>
        </div>

      </div>
    </ModalContainer>
  )
}

export default ReportModal2d